// extracted by mini-css-extract-plugin
export var modalBox = "S_w3";
export var backdrop = "S_w4";